<script lang="ts" setup>
const paymentStore = usePaymentStore()

const sortedCurrencies = computed(() => paymentStore.getSortedCurrencies)

const selectedCurrency = defineModel<Currency>({ get: value => value ?? sortedCurrencies.value[0] })
</script>

<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn color="white" raised data-cy="currency_switcher_button" v-bind="props">
        {{ selectedCurrency }}
        <v-icon class="mr-n2">custom:expand_more</v-icon>
      </v-btn>
    </template>
    <v-list data-cy="currency_menu">
      <v-list-item v-for="currency in sortedCurrencies" :key="currency" @click="selectedCurrency = currency">
        {{ currency }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>
